import { combineReducers } from "redux";
import alertSlice from "./Alert/alert.slice";
import authenticationSlice from "./authentication/authentication.slice";
import pageDataSlice from "./pageData/pageData.slice";
import loaderSlice from "./Loader/loader.slice";
import toastSlice from "./Toast/toast.slice";
import pageheaderSlice from "./PageHeader/pageheader.slice";

const rootReducer = combineReducers({
  authentication: authenticationSlice,
  alertState: alertSlice,
  pageData: pageDataSlice,
  loaderState: loaderSlice,
  toastState: toastSlice,
  pageHeaderState: pageheaderSlice,
});

export default rootReducer;
